import React from "react";
import Rating from "../../../assets/images/rating.png";
import RightIcon from "../../../assets/images/rightIconBlue.svg";
import FeaturedIcon from "../../../assets/images/FeaturedIconOrange.svg";
import KnowledgehubIcon from "../../../assets/images/knowledgehubIcon.svg";
import ApplyForCAC from "../../../assets/images/applyforcacIcon.svg";
import styles from "../Membership.module.css";

export default function KnowledgeHub() {
  return (
    <section className={styles.knowledgeHub}>
      <div className={styles.container}>
        <h3>
          Knowledge Hub vs <span>CAC Comparison</span>
        </h3>
        <h5>
          Understanding the differences between our institutional membership
          tiers
        </h5>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Features</th>
              <th>
                Knowledge Hub
                <span>Premium Tier</span>
              </th>
              <th>
                CAC
                <span>Standard Tier</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Minimum Researchers</td>
              <td>100+</td>
              <td>50+</td>
            </tr>
            <tr>
              <td>Research Output</td>
              <td>200+ Publications</td>
              <td>50+ Publications</td>
            </tr>
            <tr>
              <td>International Collaboration</td>
              <td>
                <img src={RightIcon} alt="right" />
              </td>
              <td>
                {" "}
                <img src={RightIcon} alt="right" />
              </td>
            </tr>
            <tr>
              <td>Funding Priority</td>
              <td>
                {" "}
                <img src={Rating} alt="star" /> High Priority
              </td>
              <td>
                <img src={Rating} alt="star" /> Standard
              </td>
            </tr>
            <tr>
              <td>Event Hosting Rights</td>
              <td>Unlimited</td>
              <td>Up to 2/Year</td>
            </tr>

            <tr>
              <td>Global Recognition</td>
              <td>
                <img src={FeaturedIcon} alt="star" /> Featured
              </td>
              <td>Listed</td>
            </tr>
            <tr>
              <td>Research Collaboration Platform</td>
              <td>
                <img src={RightIcon} alt="right" />
              </td>
              <td>
                <img src={RightIcon} alt="right" />
              </td>
            </tr>
            <tr>
              <td>Dedicated Support Manager</td>
              <td>
                <img src={RightIcon} alt="right" />
              </td>
              <td>
                <img src={RightIcon} alt="right" />
              </td>
            </tr>
            <tr>
              <td>Application Process</td>
              <td>Comprehensive Review</td>
              <td>Standard Review</td>
            </tr>
          </tbody>
        </table>
        <div className={styles.blockknoledgehubOuter}>
          <div className={styles.blockknoledgehub}>
            <div className={styles.image}>
              <img src={KnowledgehubIcon} alt="KnowledgehubIcon" />
            </div>
            <h6>Apply for Knowledge Hub</h6>
            <p>
              Join our premium tier for maximum benefits and global recognition
            </p>
            <button className={styles.primaryBtn}>Apply Now</button>
          </div>
          <div className={styles.blockknoledgehub}>
            <div className={`${styles.image} ${styles.orange}`}>
              <img src={ApplyForCAC} alt="ApplyForCAC" />
            </div>
            <h6>Apply for CAC</h6>
            <p>Start your journey with our standard membership tier</p>
            <button className={styles.primaryBtn}>Apply Now</button>
          </div>
        </div>
      </div>
    </section>
  );
}
